const MuiSelect = {
    root: {

    },
    outlined: {

    },
};
export default MuiSelect;
